import type {ActivesValuationItem} from "#app/domain/funnel/activesValuation";

import {apiTags, baseApi} from "../baseApi";

import {
    CLIENT_VALUATIONS_CACHE_SEC,
    fetchUsersTodayValuationAggregate,
} from "./atonValuationAggregateFetch";
import {buildClientValuationsIndex, type ClientValuationSource} from "./buildClientValuationsIndex";


export type ManagerTodayValuationsResult = {
    rows: ActivesValuationItem[];
    fetchedAt: number;
};

export type ManagerTodayValuationsArg = {
    managerId: number;
};

export const clientValuationsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getManagerTodayValuations: builder.query<
            ManagerTodayValuationsResult,
            ManagerTodayValuationsArg
        >({
            async queryFn({managerId}) {
                try {
                    const rows = await fetchUsersTodayValuationAggregate(managerId);
                    return {
                        data: {
                            rows,
                            fetchedAt: Date.now(),
                        },
                    };
                } catch (error: any) {
                    const err = error as {status?: number; message?: string};
                    return {
                        error: {
                            status: typeof err?.status === "number" ? err.status : 500,
                            data: err?.message ?? error,
                        },
                    };
                }
            },
            providesTags: (_result, _error, arg) => [
                {type: apiTags.ClientValuation, id: `manager-${arg.managerId}`},
            ],
            keepUnusedDataFor: CLIENT_VALUATIONS_CACHE_SEC,
        }),
    }),
});

export const {
    useGetManagerTodayValuationsQuery,
    useLazyGetManagerTodayValuationsQuery,
} = clientValuationsApi;

export function buildIndexFromManagerValuations(
    clients: ClientValuationSource[],
    bulk: ManagerTodayValuationsResult | undefined
) {
    if (!bulk?.rows) {
        return {};
    }
    return buildClientValuationsIndex(clients, bulk.rows, bulk.fetchedAt);
}
